{
  "already_host": "This Run runs on your PC already.",
  "approvals_missing": "It still needs approvals.",
  "blocked": {
    "administrator": "An administrator can add you.",
    "ask": "Ask for it",
    "canAdd_one": "{{names}} can add you.",
    "canAdd_other": "{{names}} can add you.",
    "haveIt": "{{groups}} have it.",
    "need": "You need “{{permission}}”",
    "reason": "Why (optional)",
    "requested": "Requested on {{date}}.",
    "withdraw": "Withdraw"
  },
  "change_set_state": "This change set isn't in review now.",
  "closed": "This Run is closed. Fork it to go on.",
  "curates_none": "You don't curate what this changes.",
  "dmw_core": "DMW's own project is read-only.",
  "merge_blocked": "Something blocks merging it.",
  "missing_permission": "You don't have the permission this needs.",
  "no_active_workflow": "This Run follows no process schema now.",
  "not_deletable": "This project can't be deleted.",
  "not_host": "Only the person on whose PC this Run runs can do this. Run it on your PC to do it yourself.",
  "not_own_route": "This runs on your own agent: run the Run on your PC to run it.",
  "nothing_to_review": "There's nothing to review here.",
  "project_not_active": "This project isn't active.",
  "request_waiting": "A person step is waiting for its answer. Answer it first.",
  "saved_not_host": "This Run is not connected: until it is, only the person on whose PC it runs can do this.",
  "step_already_ran": "The Run continues only to a step that hasn't run yet.",
  "step_not_answerable": "Its Run no longer waits for this answer.",
  "step_not_skippable": "This step can't be skipped now.",
  "turn_open": "Wait until the agent has finished."
}
